import { useFela } from 'react-fela';

import * as felaRules from './SecretsDivider.rules';

export const SecretsDivider = () => {
    const { css } = useFela();

    return <div className={css(felaRules.divider)} />;
};
